var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Button, RobotMessage, Menu } from '../components';
export var StepContent = React.memo(function (_a) {
    var step = _a.step;
    return (_jsx("div", __assign({ className: "chat-app-content" }, { children: step === 'navigation' ? (_jsx(Menu, {})) : (_jsxs(_Fragment, { children: [_jsx(RobotMessage, {}), _jsx(Button, { buttonType: "back" })] })) })));
});
